import { Component, computed, effect, inject, signal } from '@angular/core';
import { Franchise } from 'src/app/models/franchise.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { DebugService } from 'src/app/services/app/debug.service';
import { Title } from '@angular/platform-browser';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FounderItem, FoundersSelection } from '@/models/founder-item.model';
import { FoundersSlotsService } from '@/services/app/founders-slots.service';
import { OfficesService } from '@/services/api/franchises.service';
import { NavLockService } from '@/services/app/nav-lock.service';

@Component({
    selector: 'app-founders',
    imports: [
      CommonModule,
      ConfirmDialogModule,
      ToastModule,
      SelectModule,
      ButtonModule,
      ConfirmDialogModule,
      FormsModule,
      InputTextModule
    ],
    template: `
    <p-confirmDialog />
<p-toast />
<div class="w-full card p-3 border-round" style="min-height: 300px;">
<div class="grid grid-cols-12 gap-2">
  <div  class="flex items-center col-span-12 mb-2 md:col-span-2 md:mb-0 text-right">
  <label class="text-right w-full mr-2 font-bold" style="align-text: right;">Office</label>
  </div>
                        
                        <div class="col-span-12 md:col-span-9">
                        <p-select #officeDropdown
    [options]="offices" 
    [ngModel]="officeService.selectedOffice()" 
    optionLabel="CityCode"
    [style]="{'width':'100%'}" 
    (onChange)="onChangeOffice($event.value)"
    placeholder="Select an office" />

                        </div>
                        <p-button class="col-span-12 mb-2 md:col-span-1" [label]="saving() ? 'Saving' : 'Save'" [icon]="saving() ? 'pi pi-spin pi-spinner' : 'pi pi-save'" (onClick)="saveList()" [disabled]="saved() || saving()"/>
                    </div>
       
<div *ngIf="!noList else noListFound">
    <div class="w-full" *ngFor="let list of foundersSlotsService.slots()">
        <div class="text-900 text-xl mb-3 mt-3 text-left font-medium">{{list.name}} <span class="text-500" *ngIf="debugService.debugMode()"> - {{list.slotId}}</span></div>
        <div *ngFor="let assembly of list.Assemblies; let first = index" class="surface-card border-2 p-3 flex align-items-center cursor-pointer"
            [ngClass]="{
                'surface-border': !isSelected(list.slotId, assembly.AID), 
                'border-primary': isSelected(list.slotId, assembly.AID),
                'border-round-top': first === 0
                }" 
                (click)="selectSlot(list.slotId, assembly.AID)"
                >
            <div class="w-full flex align-items-center pr-4">
                    <i [class]="isSelected(list.slotId, assembly.AID) ? 'pi pi-circle-on mr-3' : 'pi pi-circle-off mr-3'" style="font-size: 1.5rem; color: var(--primary-color)"></i>
                <div class="font-medium" [innerHTML]="assembly.Description"></div>
            </div>
            <div class="w-1 text-right" *ngIf="debugService.debugMode()">
                <span class="font-medium">{{assembly.AID}}</span>
            </div>
        </div>
        <div class="surface-card border-2 p-3 border-round-bottom flex align-items-center cursor-pointer"
            [ngClass]="{'surface-border': !isNone(list.slotId), 'border-primary': isNone(list.slotId)}" (click)="selectNone(list.slotId)">
            <div class="w-full flex align-items-center pr-4">
                <i [class]="isNone(list.slotId) ? 'pi pi-circle-on mr-3' : 'pi pi-circle-off mr-3'" style="font-size: 1.5rem; color: var(--primary-color)"></i>
                <div class="font-medium">None</div>
            </div>
        </div>
    </div>
</div>
<ng-template #noListFound>
    <div class="w-full p-3 align-items-center flex flex-column mb-10" >
        <br>
        <br>
        <p class="text-500 font-bold">No list found</p>
    <div>
    </div>
    </div>
</ng-template>
</div>
    `
})
export class FoundersComponent {
  public foundersSlotsService = inject(FoundersSlotsService);
  public officeService = inject(OfficesService);
  private navLockService = inject(NavLockService);
  private confirmationService = inject(ConfirmationService);
  private messageService = inject(MessageService);
  private route = inject(ActivatedRoute);
  public debugService = inject(DebugService);
  private titleService = inject(Title);

  fid: number = 0;
  saving = signal(false);
  saved = signal(true);
  private navigationEffect: ReturnType<typeof effect>;
  noList: boolean = false;
  office = computed(() => this.officeService.selectedOffice());

  selections = signal<FoundersSelection[]>([]);

  originalSelections = signal<FoundersSelection[]>([]);

  get selectedList() {
    return this.foundersSlotsService.selectedList();
  }

  constructor(
  ) {
    this.titleService.setTitle('Landmark Ops - Founders');
    // if(this.officeService.offices().length === 0) {
    //   this.officeService.fetchOffices();
    // }

 // Setup the navigation attempt handler with URL
 this.navigationEffect = this.navLockService.onNavigationAttempt((url: string) => {
  this.handleNavigationAttempt(url);
});
    this.foundersSlotsService.populateSlots();
    this.foundersSlotsService.populateLists();

    this.route.queryParamMap.subscribe(params => {
      this.fid = Number(params.get('fid'));
      // Handle the case where fid is null or has a value
      if (this.fid) {
        console.log(`FID: ${this.fid}`);
        // Add logic to handle the presence of fid
      } else {
        console.log('FID is not provided');
        // Add logic to handle the absence of fid
      }
    });

    effect(() => {
      const list = this.foundersSlotsService.selectedList();
      const offices = this.officeService.getFilteredOffices('assemblySlots', 'edit');
      if (offices && offices.length > 0 && this.fid > 0) {
        this.officeService.setSelectedOfficeById(this.fid);
      }
      console.log('list', list);
      if (list && list.length > 0) {
        this.buildSelections(list);
        this.noList = false;
      } else {
        console.log('no list');
        this.noList = true;
      }
    });
  }

  get offices() {
    return this.officeService.getFilteredOffices('assemblySlots', 'edit')
  }

  private setUnsavedChanges(changed: boolean) {
    this.saved.set(!changed);
    this.navLockService.setLock(changed);
  }

  private clearUnsavedChanges() {
    this.saved.set(true);
    this.navLockService.setLock(false);
  }

  handleNavigationAttempt(attemptedUrl: string) {
    this.confirmationService.confirm({
      message: 'You have unsaved changes. Are you sure you want to leave?',
      accept: async () => {
        this.clearUnsavedChanges();
        await this.navLockService.navigateToAttemptedRoute(attemptedUrl);
      }
    });
  }

  canDeactivate(): boolean {
    return this.saved();
  }

  buildSelections(list: FounderItem[]) {
    const selections = [];
    for (const item of list) {
      selections.push({
        slotId: item.slotId,
        AID: item.AID,
        aSlotId: item.aSlotId,
        changed: false
      });
    }
    this.selections.set(selections);
    this.originalSelections.set(selections);
    this.clearUnsavedChanges();
    this.noList = false;
  }


  checkBeforeDropdown(event: any) {  // Change parameter to get the full event
    if(!this.saved()) {
      this.confirmationService.confirm({
        message: 'You have unsaved changes. Are you sure you want to change office?',
        accept: async () => {
          this.clearUnsavedChanges();
          this.onChangeOffice(event.value);
        },
        reject: () => {
          // Force the dropdown to revert to the previous value
          event.originalEvent.target.value = this.office();
          // If using p-select with options, you might need this instead:
          if (event.target) {
            event.target.value = this.office();
          }
        }
      });
    }
    else {
      this.onChangeOffice(event.value);
    }
  }

  onChangeOffice(office: Franchise) {
    const fid = office.FID;
    console.log('onChangeOffice triggered:', office);
    if (fid) {
      this.officeService.setSelectedOfficeById(fid);
    }
    else if (this.officeService.offices().length > 0) {
      const office = this.officeService.offices()[0];
      this.officeService.setSelectedOfficeById(office.FID);
    }
}

createList() {
  console.log('createList');
}

selectSlot(slotId: number, AID: number) {
  console.log('selectSlot', slotId, AID);
  const selections = this.selections();
  const index = selections.findIndex(selection => selection.slotId === slotId);
  
  if (index !== -1) {
    const originalAID = this.originalSelections().find(s => s.slotId === slotId)?.AID;
    const changed = AID !== originalAID;
    console.log('originalAID', originalAID, AID, changed);
    
    const updatedSelections = [...selections];
    updatedSelections[index] = { ...updatedSelections[index], AID, changed };
    
    this.selections.set(updatedSelections);
    this.checkForChanges();
  }
}

checkForChanges() {
  const changed = this.selections().filter(s => s.changed).length > 0
  this.setUnsavedChanges(changed);
}

isSelected(slotId: number, AID: number) {
  return this.selections().some(selection => selection.slotId === slotId && selection.AID === AID);
}

isNone(slotId: number) {
  return this.selections().some(selection => selection.slotId === slotId && selection.AID === null);
}

clearChanged() {
  const selections = this.selections()
  for(const selection of selections) {
    selection.changed = false;
  }
  this.selections.set(selections);
  this.originalSelections.set(selections);
}

selectNone(slotId: number) {
  const selections = this.selections();
  const index = selections.findIndex(selection => selection.slotId === slotId);
  
  if (index !== -1) {
    const originalAID = this.originalSelections().find(s => s.slotId === slotId)?.AID;
    const changed = null !== originalAID;
    
    const updatedSelections = [...selections];
    updatedSelections[index] = { ...updatedSelections[index], AID: null, changed };
    
    this.selections.set(updatedSelections);
    this.checkForChanges();
  }
}

setList(FID: number) {
  this.foundersSlotsService.setListByFID(FID);
}

saveList() {
  this.saving.set(true);
  console.log('saveList', this.selections());
  const selections = this.selections().filter(s => s.changed);
  this.foundersSlotsService.saveList(selections).subscribe({
    next: (res) => {
      this.saving.set(false);
      this.clearUnsavedChanges();
      this.clearChanged();
      this.messageService.add({severity:'success', summary:'Success', detail:'List saved'});
    },
    error: (err) => {
      this.saving.set(false);
      this.messageService.add({severity:'error', summary:'Error', detail:'Error saving list'});
    }
  });
  this.foundersSlotsService.saveList(this.selections()).subscribe((res: any) => {
    console.log('list saved', res);
    this.clearUnsavedChanges();
  });
}

ngOnDestroy() {
  // Cleanup the effect
  this.navigationEffect.destroy();
  this.titleService.setTitle('Landmark');
}

}
